// React Dependencies
import React, { useEffect } from 'react';

// External Dependencies
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Icon, MenuItem, MenuList } from '@material-ui/core';

// Internal Dependencies
import { Url } from '../../../common/constants';
import { IsEmpty } from '../../../common/checks';
import apiService from '../../../services.js/apiService';
import { editPage } from '../../../actions/admin/pageAction';
import LoyaltyCardRouter from './router';

const LoyaltyCards = ({ match, pageInView, dispatchEditPage }) => {
  const { pageId, loyaltyCardId } = match.params;

  useEffect(() => {
    const getPageData = async () => {
      const p = await apiService.getPageById(pageId);
      dispatchEditPage(p);
    };

    if (!IsEmpty(pageId)) {
      getPageData();
    }
  }, [pageId]);

  return (
    <div className="row">
      <div className="col-md-12">
        <div className="d-flex justify-content-start content-header">
          <h1 className="d-flex align-items-center">
            <Link to={`${Url.LoyaltyCards.replace(':pageId', pageId)}`} title="Back" className="d-flex align-items-center">
              <Icon className="back">arrow_back</Icon>
            </Link>
            {pageInView ? pageInView.name : ''}
            {` / loyalty card / ${loyaltyCardId}`}
          </h1>
        </div>
        <div className="row">
          <div className="col-md-2" style={{ backgroundColor: '#fff' }}>
            <MenuList>
              <Link to={`${Url.LoyaltyCards.replace(':pageId', pageId)}`}><span><MenuItem>Loyalty Cards</MenuItem></span></Link>
              <Link to={`${match.url}`}><span><MenuItem>Info</MenuItem></span></Link>
              <Link to={`${match.url}/stampSettings`}><span><MenuItem>Stamps</MenuItem></span></Link>
              <Link to={`${match.url}/participatingOutlets`}><span><MenuItem>Participate Outlet</MenuItem></span></Link>
              <Link to={`${match.url}/faqs`}><span><MenuItem>FAQs</MenuItem></span></Link>
            </MenuList>
          </div>
          <div className="col-md-10 card-left">
            <LoyaltyCardRouter match={match} />
          </div>
        </div>
      </div>
    </div>
  );
};

LoyaltyCards.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      pageId:        PropTypes.string.isRequired,
      loyaltyCardId: PropTypes.string.isRequired,
    }),
    url: PropTypes.string.isRequired,
  }).isRequired,

  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,

  pageInView: PropTypes.shape({
    id:   PropTypes.number,
    name: PropTypes.string,
  }),

  dispatchEditPage: PropTypes.func.isRequired,
};

LoyaltyCards.defaultProps = {
  pageInView: { id: null, name: null },
};

const mapStateToProps = (state) => ({
  pageInView: state.admin.page.pageInView,
});

const mapDispatchToProps = (dispatch) => ({
  dispatchEditPage: (p) => dispatch(editPage(p)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoyaltyCards);
